module.exports = __webpack_public_path__ + "img/plugin.71b16b67.svg";